(function () {
  function emptyLabel() {
    return window.B2B_REGISTRATION_FILE_EMPTY_LABEL || "Add a file";
  }

  function inB2bForm(el) {
    return !!(
      el &&
      (el.closest(".b2b-registration-form") ||
        el.closest("#bss-b2b-registration-form") ||
        el.closest("#bss-b2b-register-form"))
    );
  }

  function enhanceFileInput(input) {
    if (!input || input.type !== "file" || input.dataset.b2bFileEnhanced === "1") return;
    if (!inB2bForm(input)) return;

    input.dataset.b2bFileEnhanced = "1";

    var wrap = document.createElement("div");
    wrap.className = "b2b-file-input__wrap";

    var text = document.createElement("span");
    text.className = "b2b-file-input__custom-text";
    text.setAttribute("aria-live", "polite");

    input.classList.add("b2b-file-input__native");

    var parent = input.parentNode;
    if (!parent) return;

    parent.insertBefore(wrap, input);
    wrap.appendChild(input);
    wrap.appendChild(text);

    function update() {
      var files = input.files;
      text.textContent =
        files && files.length ? files[0].name : emptyLabel();
    }

    input.addEventListener("change", update);
    input.addEventListener("input", update);
    update();
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var list = scope.querySelectorAll
      ? scope.querySelectorAll('input[type="file"]')
      : [];

    if (!list.length && scope.matches && scope.matches('input[type="file"]')) {
      list = [scope];
    }

    Array.prototype.forEach.call(list, function (input) {
      enhanceFileInput(input);
    });
  }

  function observeForm() {
    var form = document.getElementById("bss-b2b-register-form");
    if (!form || form.dataset.b2bFileObserve === "1") return;
    form.dataset.b2bFileObserve = "1";

    var t;
    var mo = new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(function () {
        scan(document);
      }, 50);
    });
    mo.observe(form, { childList: true, subtree: true });
  }

  function observeFormWhenReady() {
    if (document.getElementById("bss-b2b-register-form")) {
      observeForm();
      return;
    }
    if (!document.body || document.body.dataset.b2bFileFormWatch === "1") return;
    document.body.dataset.b2bFileFormWatch = "1";

    var obs = new MutationObserver(function () {
      if (document.getElementById("bss-b2b-register-form")) {
        obs.disconnect();
        delete document.body.dataset.b2bFileFormWatch;
        observeForm();
        scan(document);
      }
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }

  function boot() {
    scan(document);
    observeForm();
    observeFormWhenReady();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", function (e) {
    scan(e.target);
    observeForm();
    observeFormWhenReady();
  });
})();
